import React from "react"
import {Box, Button, Column, Title} from "@allxsmith/bestax-bulma";
import useInput from "../../../hooks/useInput";
import usePostDepartment from "../../../hooks/usePostDepartment";


function NewDepartment(){
    let [departmentName, departmentNameInput, setDepartmentName] = useInput({
        type: "text",
        label: "Department Name"
    });
    const [, postDepartment] = usePostDepartment({
        name: departmentName
    });
    const onClick = () => {
        postDepartment().then(setDepartmentName(""));
    };

    return (
        <Box>
            <details>
                <summary><Title>Add Department</Title></summary>
            <Column>
                {departmentNameInput}
            </Column>
            <Column>
                <Button
                   color={"success"}
                   onClick={onClick}
                   isFullWidth
                >
                    Add +
                </Button>
            </Column>
            </details>
        </Box>
    );
}
export default NewDepartment;